import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	content: {
		id: 'software-onboarding-nudges--next.navigation-profile.content',
		defaultMessage:
			'To reopen quickstart, select your profile icon, then {tagStart}Open Quickstart{tagEnd}. If you’re looking for extra support, select {tagStart}Help{tagEnd} (?) to find articles that relate to your task.',
		description:
			'Nudge content that will show up around the profile button when the user dismisses Quickstart.',
	},
});
